export default __webpack_public_path__ + "static/7_26-d63ace691b4a90b00083cfe7234d73b5.png";